import { render } from "./DraggableCard.vue?vue&type=template&id=da2b9792&scoped=true"
import script from "./DraggableCard.vue?vue&type=script&lang=js"
export * from "./DraggableCard.vue?vue&type=script&lang=js"

import "./DraggableCard.vue?vue&type=style&index=0&id=da2b9792&lang=scss&scoped=true"
import "./DraggableCard.vue?vue&type=style&index=1&id=da2b9792&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da2b9792"]])

export default __exports__